<template>
    <div class="cabinet" :class="{'type-small' : typeSmall}">
        <div class="user-profile">{{ userShortName }}</div>

        <ul class="menu">
            <li>
                <span :title="hasAdminAccess ? 'Admin' : 'User'">
                    <i :class="[hasAdminAccess ? 'icon-wrench' : 'icon-user']"></i> {{ userName }}
                </span>
            </li>

            <li class="item" :class="{active: active('trims')}">
                <router-link :to="{name: 'trims'}">All trims</router-link>
            </li>
            <!-- My trims menu item hidden -->
            <!--
            <li class="item" :class="{active: active('my-trims')}">
                <router-link :to="{name: 'my-trims'}">My trims</router-link>
            </li>
            -->

            <template v-if="hasAdminAccess">
                <hr>

                <li class="item" :class="{active: active('settings')}">
                    <router-link :to="{name: 'settings'}">Settings</router-link>
                </li>

                <li class="item" :class="{active: active('users')}">
                    <router-link :to="{name: 'users'}">Users</router-link>
                </li>
            </template>

            <hr>

            <li class="app-version">
                <span title="Info"><i class="icon-info-circled"></i> Version: {{ appVersion }}</span>
            </li>
            <li>
                <span class="link" @click="logout">Logout<i class="icon-angle-double-right"></i></span>
            </li>
        </ul>
    </div>
</template>

<script>
    import { mapState, mapGetters, mapActions } from 'vuex';

    export default {
        name: "UserCabinetMenu",

        props: [
            'typeSmall',
        ],

        computed: {
            ...mapState([
                'appVersion',
            ]),

            ...mapState('authentication', [
                'userId',
                'userName',
            ]),

            ...mapGetters('authentication', [
                'hasAdminAccess',
            ]),

            userShortName() {
                let str = this.userName;

                // get first char each of the words
                let res = str.split(/\s/).reduce((response,word)=> response+=word.slice(0,1),'');

                // display only the first two chars
                return res.slice(0, 2);
            },

        },

        methods: {
            ...mapActions('authentication', [
                'logout',
            ]),

            active(routeName) {
                let current = this.$router.currentRoute.value.name;

                return current === routeName;
            },

        },

    }
</script>

<style scoped>
    .cabinet {
        position: relative;
        z-index: 1;
        cursor: default;
    }

    .cabinet:hover .menu {
        display: block;
    }

    .user-profile {
        width: 40px;
        height: 40px;
        margin-left: auto;
        border-radius: 50%;
        font-size: 20px;
        line-height: 40px;
        font-weight: 700;
        text-align: center;
        text-transform: uppercase;
        color: #fff;
        background: #2E2E2E;
    }

    .type-small .user-profile {
        width: 33px;
        height: 33px;
        border: 1px solid #ddd;
        font-size: 16px;
        line-height: 34px;
        color: #555;
        background: #fff;
    }

    .menu {
        display: none;
        position: absolute;
        top: 100%;
        right: 0;
        width: 200px;
        margin: 5px 0 0;
        padding: 6px 0;
        border-radius: 4px;
        list-style: none;
        background: #fff;
        box-shadow: 2px 2px 5px #555;
    }

    .menu::before {
        content: '';
        position: absolute;
        top: -15px;
        left: 0;
        width: 100%;
        height: 15px;
    }

    li {
        padding: 6px 12px;
        cursor: default;
    }

    .item {
        padding: 0;
    }

    .item a {
        display: block;
        padding: 6px 12px;
    }

    .item:hover {
        /*background: #e7eeef;*/
        background: #efefef;
    }

    .item.active {
        font-weight: 700;
        /*background: #e7eeef;*/
        background: #efefef;
    }

    hr {
        margin: 6px 12px;
    }

    .app-version {
        margin: 0 0 -4px;
        font-size: 15px;
        color: #333;
    }
</style>